import React from "react"
import { Tooltip } from "../common/Tooltip"
import { daysDiff, formatDate } from "../../services/Utils"
import classNames from "classnames"

export class Forecast extends React.Component {
  constructor(props) {
    super(props)
  }

  // match with ForecastHelper#forecast_up_arrow
  renderForecastUpArrow(forecast) {
    const arrowClass = forecast.in_qty > 0 ? 'fa fa-caret-up fa-2x text-success' : 'fa'

    return (
      <div className='forecast-up-arrow'>
        <span className={ arrowClass }></span>
      </div>
    )
  }

  // match with ForecastHelper#forecast_down_arrow
  renderForecastDownArrow(forecast) {
    const arrowClass = forecast.out_qty > 0 ? 'fa fa-caret-down fa-2x text-danger' : 'fa'

    return (
      <div className='forecast-down-arrow'>
        <span className={ arrowClass }></span>
      </div>
    )
  }

  // match with ForecastHelper#po_indicator
  renderPoIndicator(forecast) {
    if (!forecast.earliest_draft_po) {
      return <div className='p-1'></div>
    }

    const id = `tooltip-${ forecast.id }`
    return (
      <div id={ id } className='p-1 bg-success'>
        <Tooltip placement='bottom' target={ id }>{ `Draft PO: ${ formatDate(forecast.earliest_draft_po) }` }</Tooltip>
      </div>
    )
  }

  isMonday(forecast) {
    return new Date(forecast.on).getUTCDay() == 1
  }

  // match with ForecastHelper#forecast_styling
  forecastStyling(forecast) {
    if (forecast.close_qty < 0) {
      return 'border border-danger text-danger font-weight-bold'
    } else if (forecast.is_sequence) {
      return 'bg-warning'
    } else if (forecast['issue?']) {
      return 'alert-danger'
    } else if (forecast.is_replenishment) {
      return 'border border-info small'
    } else {
      return 'text-muted small'
    }
  }

  renderForecast() {
    const multiplier = this.props.product_unit.split_multiplier || 1
    const forecasts = this.props.forecasts
    // match with ForecastHelper#forecast_display
    const forecast_columns = forecasts.map((forecast_day) => {
      const quantity = forecast_day.stocked_qty * multiplier
      const cellClass = classNames('text-center border-bottom pb-0', { 'border-left': this.isMonday(forecast_day) })

      return (
        <td className={ cellClass } key={ forecast_day.on }>
          { this.renderForecastUpArrow(forecast_day) }
          <span className={ `${ this.forecastStyling(forecast_day) } h5 px-2 rounded` }>
            { parseFloat(Number(quantity).toFixed(3)) }
          </span>
          { this.renderForecastDownArrow(forecast_day) }
          { this.renderPoIndicator(forecast_day) }
        </td>
      )
    })
    return (
      <tr>
        { forecast_columns }
      </tr>
    )
  }

  renderHeader() {
    // match with ApplicationHelper#date_column_header
    const headers = this.props.forecasts.map((forecast_day) => {
      const date = new Date(forecast_day.on)
      const weekday = date.toLocaleDateString('en-US', { timeZone: 'UTC', weekday: 'short' })
      const headerClass = classNames('forecast-date-header text-center small py-0', { 'border-left': this.isMonday(forecast_day) })
      return (
        <th key={ forecast_day.on } className={ headerClass }>
          <div className='font-weight-bold'>{ date.getUTCDate() }</div>
          <div>{ weekday }</div>
        </th>
      )
    })
    return (
      <tr>
        { headers }
      </tr>
    )
  }

  // match with ApplicationHelper#days_then_date
  renderDate(text_date) {
    if (!text_date) { return }

    return (
      <span>
        { daysDiff(text_date) }
        <span className='ml-2 small text-muted text-nowrap'>{ formatDate(text_date) }</span>
      </span>
    )
  }

  renderMaxPurchaseQuantity() {
    const maxPurchaseQuantity = this.props.forecasts[this.props.forecasts.length - 1].max_purchase_qty
    if (maxPurchaseQuantity == null) { return }

    return (
      <div className='mb-2'>
        <span className='h5'>
          <span className='badge badge-warning'>Max from vendor: { maxPurchaseQuantity }</span>
        </span>
      </div>
    )
  }

  render() {
    if (!this.props.forecasts || this.props.forecasts.length == 0) {
      return (
        <div>
          <div>
              <span className='fa fa-exclamation-triangle mr-1'></span>
              No forecast available
          </div>
          <div>
            <a data-remote='true' href={`/admin/checkout_items/${this.props.order_item_id}`}>
              View Alternatives
            </a>
          </div>
        </div>
      )
    }
    return (
      <div>
        <table className='table table-sm table-middle mb-2' >
          <thead>
            {  this.renderHeader() }
          </thead>
          <tbody>
            { this.renderForecast() }
          </tbody>
        </table>
        <div className='px-2'>
          <div className='mb-2'>
            Next Draft: { this.renderDate(this.props.forecasts[this.props.forecasts.length - 1].next_replenishment_on) }
          </div>
          { this.renderMaxPurchaseQuantity() }
          <a className='btn mr-1 btn-sm btn-outline-secondary' href={`/admin/product_units/${this.props.product_unit.id}/order_items?modal=t`} data-remote='true'>
            <span className='far fa-list-alt'></span>
          </a>
          <a data-remote='true' href={`/admin/checkout_items/${this.props.order_item_id}`}>
            View Alternatives
          </a>
        </div>
      </div>
    )
  }
}
export default Forecast